<template>
<!--<b-col md="3" sm="2" style="padding-right:3px;">-->

 <div class="int-sidebar">

	<div class="wrapper">
		<div class="top">

			<div class="int-sidebar__portion" >
        <ul v-if="this.user_type != 'Planner_Admin' && this.user_type != 'Planner'">
          <li class="nav-link">

            <!-- <i class="fa fa-file-text-o"></i>&nbsp;&nbsp;&nbsp; 
				      <span>Ordersheet Download</span> -->

            <router-link to="/ordersheet" class="nav-link design-container-details__sidebar-item flex f-w-semi-bold"> 
               <i class="fa fa-file-text-o"></i>&nbsp;&nbsp;&nbsp; 
             <span class="">Order Sheet</span>
            </router-link>    
          </li>

        </ul>
        <hr>
            <ul>

                <li class="nav-link">

                <!-- <i class="fa fa-file-text-o"></i>&nbsp;&nbsp;&nbsp; 
                    <span>Ordersheet Download</span> -->

                    <router-link to="/mccreport" class="nav-link design-container-details__sidebar-item flex f-w-semi-bold"> 
                        <i class="fa fa-file-text-o"></i>&nbsp;&nbsp;&nbsp; 
                    <span class="">MCC Report</span>
                    </router-link>    
                </li>
            </ul>
            <hr>
            <ul v-if="this.user_type != 'Planner_Admin' && this.user_type != 'Planner'">
                <li class="nav-link">

                    <router-link to="/misreport" class="nav-link design-container-details__sidebar-item flex f-w-semi-bold"> 
                        <i class="fa fa-file-text-o"></i>&nbsp;&nbsp;&nbsp; 
                    <span class="">MIS Report</span>
                    </router-link>    
                </li>
            </ul>


             <!-- misreport_planner -->
             <ul v-if="this.user_type == 'Planner_Admin' || this.user_type == 'Planner'">
                <li class="nav-link">

                    <router-link to="/misreport_planner" class="nav-link design-container-details__sidebar-item flex f-w-semi-bold"> 
                        <i class="fa fa-file-text-o"></i>&nbsp;&nbsp;&nbsp; 
                    <span class="">MIS Report</span>
                    </router-link>    
                </li>
            </ul>
               
			</div>
		</div>
	</div>
</div>


   
</template>
<script>

	import CONSTANTS from '@/utils/constants'
	import auth from '@/utils/auth'
	import Vue from 'vue'

	const axios = require('axios')

	export default {
	 data () {
	 	return {
	 	  nav_design_list :[],
      user_type: '',	
      orderlistname:['Order Sheet', 'MCC Report'],
	 	}
	 },
	 
	 created: function() { 
	 	var userData = localStorage.getItem('userData')
        var userInfo = JSON.parse(userData)
        

		var userData = localStorage.getItem('userData')
		if (userData) 
		{
			var userInfo = JSON.parse(userData)
			this.user_type = userInfo[0].user_type;	
            // console.log("this.user_twwwwwwwwwwwypethis.user_type", this.user_type)
		}
	 	

	 },

	 methods: { 
	 




	 }

	};
</script>
<style>

.middle {
  flex-grow: 1;
  overflow: auto;
  width:98%;
}

.bottom {
 position: relative;

}

 .int-sidebar.int-sidebar--notification {
   max-width: 300px !important;
   min-width: 300px !important;
   background-color: #0277bd;
   .int-sidebar__portion:first-child {
   box-shadow: inset 0 -1px 0 0 var(--fill-grey-light2);
   }
   }
   .int-sidebar {
   
    min-width: 250px;

  
   background-color: #ffffff;
   flex-direction: column;
   z-index: 2;
   :first-child {
   border-top: 0;
   }
   }
   .int-sidebar__portion {
   border-bottom: 1px solid #d4d4d4;
   border-top: 1px solid #d4d4d4;
   align-items: center;
   }
   .int-sidebar__list {
   flex-grow: 1;
   }

</style>